import Banner from "@/component/banner"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

function Index() {
  const classnames = classModuleGenerator(styles)
  const banners = [
    {
      imageUrl: require("@/assets/images/banner-img.png"),
      intro: "精细培养教师能力，定期考核教学质量",
      name: "严格筛选教师资质",
      _id: "teaching",
    },
  ]

  const pertinences = [
    {
      name: "知识要点梳理",
      intro: "形成知识网络结构；系统梳理教材知识点",
    },
    {
      name: "考点精要解读",
      intro: "形成知识网络结构；系统梳理教材知识点",
    },
    {
      name: "高考考点分析",
      intro: "探究近年来高考特点与高频考点，根据高考命题方向，分析高考的走向",
    },
    {
      name: "典型题型训练",
      intro: "针对不同层次的学生需求，合理设计知识点练习题的难度和深度",
    },
    {
      name: "基础巩固训练",
      intro: '"能力提高训练"和"高考真题训练“等形式',
    },
  ]

  const prepares = [
    {
      name: "备教法",
      intro:
        "用适合学生的方式教学，根据学生特点权衡实用性和趣味性，在让学生增长知识的同时，还能够提升学习能力",
    },
    {
      name: "备教材",
      intro:
        "提炼初、高中教材重、难点内容；可自主研发教材，串联所有知识点，形成知识体系；通过研究教材和高考，形成知识点与考点之间的关联",
    },
    {
      name: "备学生",
      intro:
        "分层教学，对不同类型的学生做到因材施教；个性化教学，对每一位学生进行个性化专属辅导",
    },
    {
      name: "备自己",
      intro:
        "针对学生类型，形成适宜的教学风格。结合高考命题变化，形成良好的教学思维，带领学生备战高考",
    },
  ]

  return (
    <div className="teaching">
      <Banner banners={banners}>
        <div
          className={classnames("teaching-banner-text")}
          style={{
            width: "496px",
            height: "252px",
            background: `url(${require("@/assets/images/teaching-banner-text.png")}) no-repeat center/cover`,
          }}
        ></div>
      </Banner>
      <section className={classnames("strength1-container")}>
        <h3 className="section__title">
          实力雄厚的师资团队，给予学生切实的学习帮助
        </h3>
        <div className="section__inner">
          <ul className={classnames("strength1-imgs", "clearfix")}>
            {[1, 2, 3, 4].map((m) => (
              <li key={m}></li>
            ))}
          </ul>
        </div>
      </section>
      <section className={classnames("strength2-container")}>
        <h3 className="section__title">学大全日制实力师资团队</h3>
      </section>

      <section className={classnames("strength3-container")}>
        <h3 className="section__title">分析考点针对教学</h3>
        <div className="section__inner">
          <div className={classnames("strength3-wrap", "clearfix")}>
            <div className={classnames("strength3-img")}></div>
            <ul>
              {pertinences.map((m) => (
                <li key={m.name}>
                  <h5>{m.name}</h5>
                  <p>{m.intro}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className={classnames("strength4-container")}>
        <h3 className="section__title">四备要求精细培养教师能力队</h3>
        <div className="section__inner">
          <ul className={classnames("strength4-wrap", "clearfix")}>
            {prepares.map((m) => (
              <li key={m.name}>
                <h5>{m.name}</h5>
                <p>{m.intro}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className={classnames("strength5-container")}>
        <h3 className="section__title">精细化的管理模式，鼓励式的情绪管理</h3>
        <div className="section__inner">
          <ul className={classnames("strength5-wrap", "clearfix")}>
            {[1, 2, 3, 4, 5].map((m) => (
              <li key={m}></li>
            ))}
          </ul>
        </div>
      </section>
      <Material />
    </div>
  )
}

function Material() {
  const classnames = classModuleGenerator(styles)
  return (
    <section className={classnames("material-container")}>
      <h3 className="section__title">学大艺考全日制专属教材</h3>
      <div className="section__inner">
        <div className={classnames("material-wrap", "clearfix")}>
          <div className={classnames("material-intro")}>
            <h4>定制辅导方案 配套校本教材</h4>
            <ul>
              <li>根据艺考生特点，将各科知识点，化难为易删繁就简</li>
              <li>
                梳理知识架构、进行归纳分类，一、二、三轮复习主次分明，查漏补缺
              </li>
              <li>
                所学知识和配套校本试题练习相结合，海量题库以供选择，学以致用、活学活用
              </li>
              <li>
                对常考知识点、高频考点、重点、难点、易错点分类整理，系统化梳理知识结构，助力学生轻松掌握
              </li>
            </ul>
          </div>
          <ul className={classnames("material-content")}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((m) => (
              <li
                key={m}
                style={{
                  background: `url(${require("@/assets/images/material-demo" +
                    m +
                    ".png")}) no-repeat center/cover `,
                }}
              ></li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
export { Material, Index }
export default Index
